<script setup lang="ts">
import type { StatsData } from '~/utils/crystallize/pieces'

defineProps<{
  data: StatsData
}>()
</script>

<template>
  <ContentGrid is="section">
    <div class="bg-moss-500 text-moss-200 rounded-4xl text-center p-l md:p-xl full-width">
      <div class="hidden md:flex w-full justify-evenly gap-l">
        <FrontPageStat v-for="(stat, i) in data.values" :key="i" :stat="stat" />
      </div>
      <Carousel v-slot="{ item }" class="md:hidden full-width-content" autoplay :data="data.values" variant="nettbutikk">
        <FrontPageStat :stat="item" class="select-none" />
      </Carousel>
    </div>
  </ContentGrid>
</template>
